module.exports = __webpack_public_path__ + "static/media/cheer.78c8fd4a.jpg";